import { ApplicationLoader } from 'components/ApplicationLoader';
import { PageHeader } from 'components/Layout/PageHeader';
import { PageLayout } from 'components/Layout/PageLayout';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { ProblematicsTable } from '../components/ProblematicsTable';
import { useFetchProblematics } from '../hooks/useFetchProblematics';

const m = defineMessages({
  pageTitle: {
    id: 'Problematics.Page.Title',
    defaultMessage: 'Préoccupations, problématiques et sujets abordés',
  },
});

export const ProblematicsPage: React.FC = () => {
  const { formatMessage } = useIntl();

  const { problematics, isFetched: areProblematicsFetched } =
    useFetchProblematics({ staleTime: 0 });

  const isLoaded = areProblematicsFetched;

  return (
    <PageLayout pageTitle={formatMessage(m.pageTitle)}>
      <PageHeader header={formatMessage(m.pageTitle)} iconName="warning sign" />

      {isLoaded ? (
        <ProblematicsTable problematics={problematics} />
      ) : (
        <ApplicationLoader />
      )}
    </PageLayout>
  );
};
